import axios from 'axios';
import { PublicUser, User } from 'types/user';

const SULAB_AUTH_TOKEN = 'sulab_auth_token';
const SAPIEN_CHALLENGE_TOKEN = 'sapien_challenge_token';
export const getSULabToken = () => {
  let storedTokenString = localStorage.getItem(SULAB_AUTH_TOKEN);
  let token: SULabUser;
  if (storedTokenString === null) {
    return null;
  }
  token = parseJwt(storedTokenString);
  return token;
};
export const getToken = () => {
  let storedTokenString = localStorage.getItem(SAPIEN_CHALLENGE_TOKEN);
  let token: User;
  if (storedTokenString === null) {
    return null;
  }
  token = parseJwt(storedTokenString);
  return token;
};
export const getSULabTokenString = () => {
  return localStorage.getItem(SULAB_AUTH_TOKEN);
};
export const getTokenString = () => {
  return localStorage.getItem(SAPIEN_CHALLENGE_TOKEN);
};
export const storeSULabToken = (token: string) => {
  localStorage.setItem(SULAB_AUTH_TOKEN, token);
};
export const storeToken = (token: string) => {
  localStorage.setItem(SAPIEN_CHALLENGE_TOKEN, token);
};
/** Login a user and return the user data. Returns null if user does not exist */
export const login = async (
  SULabTokenStr: string
): Promise<User | undefined> => {
  storeSULabToken(SULabTokenStr);

  const res = await fetch(`${process.env.REACT_APP_API}/v1/auth/token`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Token: ${SULabTokenStr}`,
    },
  }).then((r) => {
    if (r.status === 404) {
      return null;
    } else if (r.status !== 200) {
      console.error(r);
      throw new Error('Error occured');
    }
    return r.json();
  });
  if (res === null) return undefined;
  storeToken(res.token);
  const user = getToken() as User;

  return user;
};
export const logout = () => {
  localStorage.removeItem(SULAB_AUTH_TOKEN);
  localStorage.removeItem(SAPIEN_CHALLENGE_TOKEN);
};

export const register = async (tokenStr: string, name: string) => {
  let token = getSULabToken() as SULabUser;
  return fetch(`${process.env.REACT_APP_API}/v1/users`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Token: ${tokenStr}`,
    },
    body: JSON.stringify({
      name,
      email: token.email,
    }),
  }).then(async (r) => {
    if (r.status !== 200) {
      console.error({ r });
      throw new Error((await r.json()).message);
    }
    // if (r.status !== 200) {
    // }
    return r.json();
  });
};

const parseJwt = (token: string) => {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export interface SULabUser {
  email: string;
  scope: string;
  role: string;
  services: any[];
  type: string;
  iat: number;
  exp: number;
  aud: string;
  iss: string;
}

export const needToken = () => {
  let token = localStorage.getItem(SULAB_AUTH_TOKEN);
  return token === null;
};
